import React from 'react';
import { AlertCircle, BookOpen, UserRound } from 'lucide-react';

const RISK_STYLES = {
  critical: 'border-l-rose-700 bg-rose-50/70 text-rose-900',
  high: 'border-l-orange-600 bg-orange-50/60 text-orange-900',
  medium: 'border-l-amber-500 bg-amber-50/50 text-amber-900',
  low: 'border-l-sky-500 bg-sky-50/40 text-sky-900',
};

const fmtDate = (value) => {
  if (!value) return '—';
  try { return new Date(value).toLocaleDateString(undefined, { month: 'short', day: 'numeric' }); }
  catch { return '—'; }
};

export const ReviewQueueList = ({ rows, selectedId, onSelect, loading }) => (
  <section className="flex min-h-[34rem] flex-col border border-border bg-card" data-testid="review-queue-panel">
    <header className="border-b border-border bg-panel-header/30 px-4 py-3">
      <div className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Priority queue</div>
      <div className="mt-0.5 text-[11px] text-muted-foreground" data-testid="review-queue-result-count">{rows.length} manuscripts</div>
    </header>
    <div className="min-h-0 flex-1 overflow-y-auto scroll-thin" data-testid="review-queue-list">
      {loading ? (
        <div className="p-5 text-xs text-muted-foreground" data-testid="review-queue-loading">Ranking manuscripts…</div>
      ) : rows.length === 0 ? (
        <div className="flex min-h-56 flex-col items-center justify-center px-6 text-center" data-testid="review-queue-empty">
          <AlertCircle className="h-5 w-5 text-muted-foreground" />
          <p className="mt-2 text-sm font-semibold">No reviews match these filters</p>
          <p className="mt-1 text-xs text-muted-foreground">Sync completed Loom drafts or broaden the filters.</p>
        </div>
      ) : rows.map((row) => (
        <button
          key={row.id}
          type="button"
          onClick={() => onSelect(row.id)}
          className={`w-full border-b border-l-4 border-b-border px-4 py-3 text-left transition-colors hover:bg-secondary/60 ${RISK_STYLES[row.risk_level] || RISK_STYLES.low} ${selectedId === row.id ? 'ring-2 ring-inset ring-primary' : ''}`}
          data-testid={`review-queue-row-${row.id}`}
        >
          <div className="flex items-start justify-between gap-3">
            <div className="min-w-0">
              <div className="truncate text-[13px] font-semibold text-foreground" data-testid={`review-title-${row.id}`}>{row.title}</div>
              <div className="mt-1 flex items-center gap-1.5 text-[10.5px] text-muted-foreground">
                <BookOpen className="h-3 w-3" /> {row.chapter_count || 0} chapters · {fmtDate(row.submitted_at)}
              </div>
            </div>
            <div className="shrink-0 text-right">
              <div className="font-mono-stat text-lg font-bold tabular-nums" data-testid={`review-score-${row.id}`}>{row.hybrid_score}</div>
              <div className="text-[9px] font-semibold uppercase tracking-wider">{row.risk_level}</div>
            </div>
          </div>
          <div className="mt-2 flex items-center justify-between gap-2">
            <span className="inline-flex items-center gap-1 text-[10.5px] text-muted-foreground">
              <UserRound className="h-3 w-3" /> {row.assigned_to || 'Unassigned'}
            </span>
            <span className="border border-current/20 bg-white/50 px-1.5 py-0.5 text-[9.5px] font-semibold uppercase text-foreground" data-testid={`review-status-${row.id}`}>
              {row.status?.replaceAll('_', ' ')}
            </span>
          </div>
        </button>
      ))}
    </div>
  </section>
);